var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          attrs: {
            border: "",
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("Resource.VersionNum"),
              prop: "currentVersion",
              width: "120",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelManage.SmallParcelCoefficient"),
              prop: "smallCalculateBase",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      scope.row.smallCalculationMethod === 0
                        ? _c("span", [_vm._v("*")])
                        : _vm._e(),
                      scope.row.smallCalculationMethod === 1
                        ? _c("span", [_vm._v("/")])
                        : _vm._e(),
                      _vm._v(" " + _vm._s(scope.row.smallCalculateBase) + " "),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("ChannelManage.LargeParcelCoefficient"),
              prop: "largeCalculateBase",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      scope.row.largeCalculationMethod === 0
                        ? _c("span", [_vm._v("*")])
                        : _vm._e(),
                      scope.row.largeCalculationMethod === 1
                        ? _c("span", [_vm._v("/")])
                        : _vm._e(),
                      _vm._v(" " + _vm._s(scope.row.largeCalculateBase) + " "),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.CreatePeople"),
              prop: "createUser",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getUserName(scope.row.createUser, _vm.userNameStr)
                        ) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.UpdateTime"),
              prop: "updateTime",
              width: "180",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.queryParam.pageNumber,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.queryParam.pageSize,
              total: _vm.total,
              background: "",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryParam, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryParam, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryParam, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryParam, "pageSize", $event)
              },
              "current-change": _vm.getCurrentTable,
              "size-change": _vm.getSizeTable,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }